import React from "react"
import { Helmet } from "react-helmet-async"
import SbEditable from "storyblok-react"
import { CalendlyEmbedStoryblok } from "../../../component-types-sb"
import "twin.macro"
import { useGlobalSettings } from "../../contexts/GlobalSettingsContext"
import useLocale from "../../hooks/useLocale"
import { Locale, locales } from "../../../locales"

interface Props {
  readonly blok: CalendlyEmbedStoryblok
}

const styles = {
  large: { height: "750px", minWidth: "100%" },
  small: { height: "630px", minWidth: "350px" },
}

const CalendlyEmbed: React.FC<Props> = ({ blok }) => {
  const tz = new Intl.DateTimeFormat().resolvedOptions().timeZone
  const isAmericas = (/America/u).exec(tz)
  const { preferredLang } = useLocale()
  const { calendly_americas_url, calendly_default_url, ...calendlyUrls } = useGlobalSettings()

  if (!calendly_default_url) return <p tw="text-center text-30 text-red">No default Calendly URL</p>

  // Dynamically generate localeUrls based on locales.ts
  const localeUrls = locales.reduce<Record<Locale, string>>((acc, locale) => {
    acc[locale] = calendlyUrls[`calendly_${locale}_url`] || calendly_default_url
    return acc
  }, {} as Record<Locale, string>)

  let url = blok.calendly_url

  if (!url)
    url = (isAmericas && calendly_americas_url)
      ? calendly_americas_url
      : (localeUrls[preferredLang] ?? calendly_default_url)

  return (
    <SbEditable content={blok}>
      <Helmet>
        <script type="text/javascript" src="https://assets.calendly.com/assets/external/widget.js" async />
      </Helmet>

      <div
        className="calendly-inline-widget"
        data-url={`${url}?hide_landing_page_details=1&hide_gdpr_banner=1&hide_cookie_banner=1`}
        style={styles[blok.size ?? "small"]}
      />
    </SbEditable>
  )
}

export default CalendlyEmbed
